import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FluidsSubcutaneousAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-fluids-subcutaneous-slot',
    templateUrl: './fluids-subcutaneous-slot.component.html',
    styleUrl: './fluids-subcutaneous-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsSubcutaneousSlotComponent implements SheetSlotComponentBase {

	action!: FluidsSubcutaneousAction;
	value!: string | null;

	@Input('action') set updateAction(action: FluidsSubcutaneousAction | null) {
		this.action = action as FluidsSubcutaneousAction;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}